import React from 'react';
import { Box } from '@applatform/design-system';
import LoginArt from './LoginArt/LoginArt';
import MobileBand from './MobileBand/MobileBand';

interface PublicLayoutV2Props {
  readonly children: React.ReactNode;
}

function PublicLayoutV2({ children }: PublicLayoutV2Props) {
  return (
    <Box
      css={{
        minHeight: '100vh',
        display: 'grid',
        gridTemplateColumns: '1fr',
        backgroundColor: '$white',
        '@md': {
          gridTemplateColumns: '1.05fr .95fr',
        },
      }}
    >
      <MobileBand />
      <Box css={{ display: 'none', '@md': { display: 'grid' } }}>
        <LoginArt />
      </Box>
      <Box
        as="main"
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: '$8',
          py: '$10',
          backgroundColor: '$white',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default PublicLayoutV2;
